module.exports = __webpack_public_path__ + "img/tensionn.1fa69cb2.svg";